import { useQuery } from '@tanstack/react-query'
import {
  getIppanMedicines,
  getSpecificMedicines,
} from '../../../../apis/medicines'
import { queryKeys } from '../../../../shared'

/**
 * 一般名医薬品リストを取得する Query hook
 */
export const useIppanMedicinesQuery = () => {
  return useQuery({
    queryKey: queryKeys.medicines.ippan(),
    queryFn: async () => {
      const { data } = await getIppanMedicines()
      return data
    },
  })
}

/**
 * 一般名に対応する具体的医薬品リストを取得する Query hook
 *
 * @param ippanId - 一般名医薬品のID（nullの場合はクエリを実行しない）
 */
export const useSpecificMedicinesQuery = (ippanId: string | null) => {
  return useQuery({
    queryKey: queryKeys.medicines.specific(ippanId || ''),
    queryFn: async () => {
      if (!ippanId) return []
      const { data } = await getSpecificMedicines(ippanId)
      return data
    },
    enabled: !!ippanId,
  })
}
